import React from 'react';
import { useTranslation } from 'react-i18next';

import { colors } from '@/assets/styles/colors';
import { IconScout } from '@/components/ui/images/IconScout';
import { PrimaryButton } from '@/components/ui/buttons/PrimaryButton';
import { EmployeeDimensionalFilter } from '@/components/features/attendance/EmployeeDimensionalFilter';
import type { UseEmployeeDimensionalFilterResult } from '@/hooks/attendance/common/useEmployeeDimensionalFilter';


interface MarksManagerAdvancedFiltersToggleProps {
  dimensionalFilter: UseEmployeeDimensionalFilterResult;
  onSearch: () => void;
}

// ASIS-5569/ASIS-5570: toggle "Ver filtros avanzados" + los 7 filtros dimensionales (Empresa/Área/
// Cargo/C.C./Agrupaciones/Modalidad de contrato/Estado colaborador) + Colaborador (sincronizado
// con el filtro rápido de MarksManagerQuickFilters, mismo estado). Vive junto al rango de fechas
// (Card 1). El botón "Buscar" solo aparece expandido: aplica la combinación vigente de filtros
// principales + avanzados + rápidos (ver handleAdvancedSearch en useMarksManager).
export const MarksManagerAdvancedFiltersToggle: React.FC<
  MarksManagerAdvancedFiltersToggleProps
> = ({
  dimensionalFilter,
  onSearch,
}) => {
  const { t: translate } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <button
        type="button"
        onClick={dimensionalFilter.toggleExpanded}
        className="self-start flex items-center gap-1 font-medium text-sm cursor-pointer bg-transparent border-none p-0"
        style={{ color: colors.important.main }}
        aria-expanded={dimensionalFilter.isExpanded}
        data-testid="marks-manager-toggle-advanced-filters"
      >
        {dimensionalFilter.isExpanded
          ? translate('attendance:dimensionalFilter.hide')
          : translate('attendance:dimensionalFilter.showAdvancedFilters')}
        <IconScout
          name={dimensionalFilter.isExpanded ? 'angleUp' : 'angleDown'}
          size={16}
        />
      </button>

      {dimensionalFilter.isExpanded && (
        <>
          <EmployeeDimensionalFilter
            config={{
              company: true,
              area: true,
              position: true,
              costCenter: true,
              contractModality: true,
              securityGroup: true,
              employeeStatus: true,
              employee: true,
            }}
            state={dimensionalFilter}
          />
          <PrimaryButton
            type="button"
            onClick={onSearch}
            className="self-end"
            data-testid="marks-manager-advanced-search-button"
          >
            {translate('common:actions.search')}
          </PrimaryButton>
        </>
      )}
    </div>
  );
};

export default MarksManagerAdvancedFiltersToggle;
